export const SECTION_KEYS = ['venture', 'need', 'idea', 'storyboard', 'survey'] as const
export type SectionKey = (typeof SECTION_KEYS)[number]

export const SECTION_LABELS: Record<SectionKey, string> = {
  venture: 'Venture',
  need: 'Unmet needs',
  idea: 'Ideas',
  storyboard: 'Storyboards',
  survey: 'Surveys',
}
